module.exports = __webpack_public_path__ + "img/icon-hero-rating-googleplay.6c0ee83.svg";